<template>
  <div >
    
    <nd-sms
      ref="smsRef"
      :duration="120"
      :showMobile="false"
      :tips="smsTips"
      title="身份认证"
      v-model="smsVisible"
      @retrieve="sendSmsAgain"
      @confirm="confirm"
      @countEnd="countEnd"
    ></nd-sms>

    <!-- 刷脸认证 -->
    <nd-dialog
      class="auth-dialog"
      v-model="authVisible"
      :footer="false"
      closeBtn
      @close="$emit('close')"
    >
      <div class="dialog-content">
        <div class="title">身份认证</div>
        <div class="tip">为保护您的账户信息安全，为确认当前为您本人操作，平台需对您进行身份验证。</div>

        <nd-button
          class="confirm-btn small"
          @click="faceAuth"
        >确认</nd-button>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import { getKey, isTMDMiniprogram, judgeClientSystem } from '../../../assets/utils'
import NdSms from '@/view/bankcard/components/nd-sms.vue'
import { mapActions } from 'vuex'
import wx from 'weixin-webview-jssdk'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
export default {
  name: 'message-auth',
  components: {
    NdSms
  },
  props: {
    verificationMode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      smsVisible: false, // 是否显示短信验证码弹出框
      authVisible: false,
      mobile: '',
      type: '',
      code: ''  
    }
  },
  mounted () {
    const userInfo = getKey('userInfo')
    if (this.$route.query?.result === 'PASS') {
      this.checkResult()
    }
    this.mobile = userInfo.mobile
  },
  computed: {
    smsTips () {
      return `<span> 为保护您的账户信息安全，为确认是您本人操作，需进行身份验证。验证码已发送您的手机，请查收<em>${this.formatMobile(
        this.mobile
      )}</em></span>`
    }
  },
  methods: {
    ...mapActions('message', ['messageConfirm', 'messageSendSms']),
    faceAuth () {
      const path = this.$route.path || '/message/list'
      this.$storage.set('applySerialNo', this.$route.query.recordNo)
      this.$storage.set('sceneType', 'MESSAGE_CENTER')
      this.$storage.set('returnUrl', path)
      
      if (isTMDMiniprogram()) {
        this.$router.replace(`/authentication/face-mp?sceneNo=${this.$route.query.recordNo}&sceneType=MESSAGE_CENTER`)
        return 
      }
      this.$router.replace(`/authentication/face?sceneNo=${this.$route.query.recordNo}&sceneType=MESSAGE_CENTER&redirectUrl=${path}`)
    },
    async checkResult () {
      const { success } = await this.messageConfirm({
        smsCode: this.code,
        recordNo: this.$route.query.recordNo
      })
      if (success) {
        this.$message('操作成功')
      } 
      console.log(this.code, success)
      if ((this.code && success) || !this.code) {
        setTimeout(() => {
          if (isTMDMiniprogram()) {
            wx.miniProgram.navigateBack()
          } else if (hasNativeMethod('navigateTo') && (judgeClientSystem() !== 'IOS' || (judgeClientSystem() === 'IOS' && getKey('appChannel') === 'official-iOS'))) {
            jsBridge('exit')
          } else {
            this.$router.replace('/mine')
          }
        }, 1500)
      }
    },
    handleVerifi (skip = false) {
      if (this.verificationMode === 'SMS') {
        this.smsVisible = true
        this.handleSendMsg()
      } else if (this.verificationMode === 'FACE_ID') {
        if (skip) {
          this.faceAuth()
          return
        }
        this.authVisible = true
      } else if (this.verificationMode === 'CLICK') {
        this.checkResult()
      }
    },
    async handleSendMsg () {
      this.messageSendSms({
        recordNo: this.$route.query.recordNo
      })
    },
    sendSmsAgain (reset) {
      this.handleSendMsg()
      reset()
    },
    countEnd () {},
    confirm (code) {
      this.code = code
      this.checkResult()
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

 .auth-dialog {
    .dialog-content {
      padding: 0 45px;
      padding-bottom: 40px;
      position: relative;
    }

    .title {
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold,PingFang SC;
      font-weight: 600;
    }
    .tip {
        font-size: 28px;
        line-height: 40px;
        margin-top: 37px;
        font-family: PingFangSC-Regular,PingFang SC;
        font-weight: 400;
        color: #999;
    }
    .confirm-btn {
      margin: 40px auto 0;
      display: block;
    }

  }
  </style>